import { AnyAction } from "redux";
import { InsuranceInfoState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState: InsuranceInfoState = {
    insurances: [],
};

const reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_GET_INSURANCE_INFO):
            return {
                ...state,
                insurances: action.payload,
            };
    }
    return state;
};

export default reducer;
